import * as i18next from "i18next";
import { context } from "../context/context";
import { LocaleType } from "../constants/constants";
import * as moment from "moment";
import { DefaultLanguageProvider } from "../common/context/application-context/default-language-provider";

export abstract class I18nManager {
    private _currentLocale: LocaleType;

    public init() {
        this._currentLocale = new DefaultLanguageProvider().get() ?? "fr-FR";
        moment.locale(this._currentLocale);

        return new Promise<void>((resolve, reject) => {
            i18next.init({
                lng: this._currentLocale,
                resources: {
                    "en-GB": { translation: this.load("en-GB") },
                    "fr-FR": { translation: this.load("fr-FR") },
                    "es-ES": { translation: this.load("es-ES") },
                    "it-IT": { translation: this.load("it-IT") },
                    "de-DE": { translation: this.load("de-DE") },
                    "pl-PL": { translation: this.load("pl-PL") },
                },
            }, err => {
                if (err) {
                    reject(err);
                }

                resolve();
            });

            moment.locale(context.settings.lang);
        });
    }

    protected abstract load(locale: LocaleType): any;
}
